// @flow
import { getFileExtension } from "data/utils";
import { type uppyFile } from "data/uppy";
import match from "mime-match";

export /**
 * will match an uppyFile to a list of allowed fileTypes (extension or media types)
 *
 * @param {uppyFile} file
 * @param {?Array<string>} fileTypes
 * @returns {boolean} true if no fileTypes configured or a match, otherwise false if not matched
 */
const isFileTypeMatch = (
    file: uppyFile,
    fileTypes: ?Array<string>
): boolean => {
    if (fileTypes == null) return true;
    const ext = getFileExtension(file.name).toLowerCase();
    const isFileType = fileTypes.some((type) => {
        // is this is a mime-type
        if (type.indexOf("/") > -1) {
            /* istanbul ignore next */
            if (!file.type) return false;
            return match(file.type.replace(/;.*?$/, ""), type);
        }

        // otherwise this is likely an extension
        /* istanbul ignore else */
        if (type[0] === ".") {
            return ext === type.toLowerCase();
        }
        return false;
    });
    return isFileType;
};

export /**
 * will validate that all fileTags are specified in uppyFile
 *
 * @param {uppyFile} file
 * @param {?Array<string>} fileTags
 * @returns {boolean} true if no fileTags configured or all exist, otherwise false if any missing
 */
const isFileTagMatch = (file: uppyFile, fileTags: ?Array<string>): boolean => {
    if (fileTags == null) return true;
    return fileTags.every((tag) =>
        Object.prototype.hasOwnProperty.call(file, tag)
    );
};
